import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

export const useInViewEvent = section => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  useEffect(() => {
    if (inView) {
      SoyuzAnalytics.sendGA4Event('show', { section });
    }
  }, [inView]);

  return ref;
};

export const InViewEvent = props => {
  const ref = useInViewEvent(props.section);
  return (
    <div ref={ref} className={props.className}>
      {props.children}
    </div>
  );
};

const withInViewEvent = section => WrappedComponent => props => {
  const ref = useInViewEvent(section);

  return (
    <div ref={ref}>
      <WrappedComponent {...props} />
    </div>
  );
};

export default withInViewEvent;
